export default "__VITE_ASSET__CdBUDKrB__"